export default () => ({
	init() {
		this.form = this.$el.querySelector('.collection-filters__form')
		if (!this.form) return

		// Calculate active filters on init and store in site store
		this.updateActiveFilterCount()

		// Store form reference for use in event handlers
		const form = this.form
		const store = this.$store

		// Add event listeners for filter buttons
		const clearButton = form.querySelector('#collection-filters__clear')
		const submitButton = form.querySelector('#collection-filters__submit')

		clearButton?.addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()

			// Reset radio buttons to "manual" sort without adding it to URL
			const manualSort = form.querySelector('#Sort-manual')
			if (manualSort) {
				manualSort.checked = true
				manualSort.name = '' // Remove from form submission
			}

			// Clear all checkboxes
			form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
				checkbox.checked = false
			})

			this.updateActiveFilterCount()

			// Preserve non-filter query params (like referrer)
			const urlParams = new URLSearchParams(window.location.search)
			const preservedParams = new URLSearchParams()

			urlParams.forEach((value, key) => {
				if (key !== 'sort_by' && !key.includes('filter')) {
					preservedParams.set(key, value)
				}
			})

			const queryString = preservedParams.toString()
			window.location.href = window.location.pathname + (queryString ? '?' + queryString : '')

			store.site.toggleFilters()
		})

		submitButton?.addEventListener('click', e => {
			e.preventDefault()
			const formData = new FormData(form)

			// Remove manual sort from URL if selected
			if (formData.get('sort_by') === 'manual') {
				formData.delete('sort_by')
			}

			// Explicitly preserve hidden inputs (like referrer)
			form.querySelectorAll('input[type="hidden"]').forEach(input => {
				if (!formData.has(input.name)) {
					formData.set(input.name, input.value)
				}
			})

			const searchParams = new URLSearchParams(formData).toString()
			const url = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`

			this.updateActiveFilterCount()
			window.location.href = url
			store.site.toggleFilters()
		})

		// Listen for Swup content replacement
		// window.swup?.hooks.on('content:replace', () => {
		// 	this.updateActiveFilterCount()
		// })

		// Set manual sort if no query params exist
		const urlParams = new URLSearchParams(window.location.search)
		const manualSort = form.querySelector('#Sort-manual')
		if (urlParams.toString() === '' && manualSort) {
			manualSort.checked = true
		}
	},

	updateActiveFilterCount() {
		const urlParams = new URLSearchParams(window.location.search)
		let count = 0

		// Count each unique parameter (including price sorting, excluding manual sort)
		urlParams.forEach((value, key) => {
			if (key === 'sort_by') {
				// Only count sort if it's price-related
				if (value === 'price-ascending' || value === 'price-descending') {
					count++
				}
				return
			}
			// Only count filter parameters (those that start with or contain 'filter')
			if (key.includes('filter')) {
				count++
			}
		})

		// Store the count in the site store
		this.$store.site.activeFilterCount = count
	},

	handleSubmit() {
		const formData = new FormData(this.form)
		const searchParams = new URLSearchParams(formData).toString()
		const url = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`

		window.location.href = url
	},
})
